import { SupplierNotificationWebService } from '@linktivity/gds-neo';
import config from '../config';

const supplierNotificationApi =
  new SupplierNotificationWebService.NotificationApi(config);

export default supplierNotificationApi;
